import { useGetCreditLimitsQuery } from "../internal/entities/credit/api/api.js";
import { selectCreditLimits } from "../internal/entities/credit/model/selectors/selectCreditLimits.js";
import { selectCreditLimitsParams } from "../internal/entities/credit/model/selectors/selectCreditLimitsParams.js";
import "../internal/entities/credit/model/selectors/selectFinancialPrograms.js";
import "../internal/entities/credit/model/selectors/selectFinancialProgramsParams.js";
import { selectInitialCreditLimits } from "../internal/entities/credit/model/selectors/selectInitialCreditLimits.js";
import "../internal/entities/credit/model/selectors/selectSelectedFinancialProgram.js";
import { CreditType } from "../internal/shared/api/types.gen.js";
import { useAppSelector } from "../internal/shared/lib/store/hooks/useAppSelector.js";
function useCreditLimits() {
  const creditLimitsParams = useAppSelector(selectCreditLimitsParams);
  const creditLimitsStateFromStore = useAppSelector(selectCreditLimits);
  const initialCreditLimits = useAppSelector(selectInitialCreditLimits);
  const isSkipCreditLimitsQuery = !creditLimitsParams;
  const {
    currentData,
    data: currentCreditLimitsData = currentData,
    isUninitialized: isUninitializedQuery,
    isLoading: isLoadingQuery,
    isFetching: isFetchingQuery,
    requestId,
    error
  } = useGetCreditLimitsQuery(creditLimitsParams, {
    skip: isSkipCreditLimitsQuery
  });
  const creditLimitsData = (creditLimitsStateFromStore == null ? void 0 : creditLimitsStateFromStore.data) ?? currentCreditLimitsData;
  const isLoading = isUninitializedQuery || isLoadingQuery || isFetchingQuery;
  const isLoadingResidual = isLoading && (creditLimitsParams == null ? void 0 : creditLimitsParams.type) === CreditType.RESIDUAL_PAYMENT;
  const isHiddenTypeField = !!error && "status" in error && error.status === 404;
  return {
    requestId,
    data: creditLimitsData,
    initialValues: initialCreditLimits,
    isLoading,
    isLoadingResidual,
    isHiddenTypeField
  };
}
export {
  useCreditLimits
};
